




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import 'jstree'
import 'jstree/dist/themes/default/style.min.css';

declare const $: any;

@Component({})
export default class TreeEditor extends Vue {
    @Prop() data!: { id: string, parent: string, text: string }[];
    @Prop({default: false}) dnd!: boolean;
    @Prop() id!: string;
    @Prop() label!: string;
    @Prop() parent!: string;
    @Prop() icon!: string;
    @Prop({default: false}) openOnLoad!: boolean;

    instance;

    @Watch("data") 
    onDataChange(value: any[]) {
        this.createEditor();
    }

    mounted() {
        this.createEditor();
    }

    @Emit('changed') changed(p: any) {
    }

    @Emit('moved') moved(p: any) {
    }

    destroyed() {
        this.instance.jstree().destroy(false);
    }

    private getData() {
        return this.data.map(item => {
            const id = item[this.id || 'id'];
            const label = item[this.label || 'text'];
            const parent = item[this.parent || 'parent'];
            const icon = item[this.icon || 'icon'];
            return {id: id ? id.toString() : '', text: label, parent: parent || '#', icon: icon, data: item};
        });
    }

    private handleChanged(e, p) {
        this.changed(p.node.data);
    }

    private handleMoved(e, p) {
        p.node.data[this.parent || 'parent'] = p.parent;
        this.moved(p.node.data);
    }

    private createEditor() {
        const self = this;
        const $container = $(this.$refs['container']);
        if (this.instance) {
            this.instance.jstree().destroy(true);
        }
        this.instance = $container.jstree({
            core: {
                data: self.getData(),
                check_callback: this.dnd
            },
            plugins: ["dnd"]
        });
        $container.on('changed.jstree', self.handleChanged);
        $container.on('move_node.jstree', self.handleMoved);
        if (this.openOnLoad) {
            $container.on('loaded.jstree', function(e, data) {$(this).jstree('open_all')});
        }
    }
}
